/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_Tax_CodeInputs */

const vi_order_form_invoice_buyer_tax_code = /** @type {(inputs: Order_Form_Invoice_Buyer_Tax_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã số thuế`)
};

/**

* @param {Order_Form_Invoice_Buyer_Tax_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_tax_code = /** @type {((inputs?: Order_Form_Invoice_Buyer_Tax_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_Tax_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_tax_code(inputs)
});